import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyA03X-vmHQfYS-cxGvgfz7sCwNbXUYDUCY",
  authDomain: "csa-app-ccebb.firebaseapp.com",
  databaseURL: "https://csa-app-ccebb-default-rtdb.firebaseio.com",
  projectId: "csa-app-ccebb",
  storageBucket: "csa-app-ccebb.appspot.com",
  messagingSenderId: "930701090054",
  appId: "1:930701090054:web:d05f6a83805e2fc523d287",
  measurementId: "G-GP75K5KFWJ",
};
export const trackingCode = process.env.trackingCode;
firebase.initializeApp(firebaseConfig);
export const analytics = firebase.analytics();
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;
